




import Vue from 'vue'
import style from './style.module.scss'

import { Discount } from '@/types/price-settings'
import cell from '@/components/root-components/product-price-setting/_common/cell.vue'

export default Vue.extend({
    name: 'min-volume-cell',
    components: {
        cell
    },
    props: {
        data: {} as () => Discount,
        typeCode: String
    },
    data() {
        return {
            style: style
        }
    },
    methods: {
        updateFromCell(data: number) {
            this.data.MinVolume = data;
        },
        onApply(data: number | string) {
            if(data || data === '' || data === 0) {
                this.$store.dispatch('addEmptyDiscountRow', { rowId: this.data.ParentId, typeCode: this.typeCode });
            }
        }
    }
})
